/* MGS Warehouse Pickup Picker — compact, ZIP-driven nearest-first.
   Default (4+ locations): just the ZIP box + "Browse all" — no cards.
   After ZIP: nearest 3, closest auto-selected. 2-3 locations: show all, no ZIP. 1: single card.
   Chosen address writes to the single hidden [data-mgs-pickup-prop] line-item property.
   Degrades to the plain list if geocoding is unavailable. */
(function () {
  'use strict';
  var ZG = {"07036":[40.6354,-74.2556,"Linden","NJ"],"07083":[40.6952,-74.2677,"Union","NJ"],"08873":[40.5007,-74.5013,"Somerset","NJ"],"11716":[40.7678,-73.1163,"Bohemia","NY"],"18102":[40.6068,-75.4781,"Allentown","PA"],"19605":[40.3886,-75.9328,"Reading","PA"],"23455":[36.8881,-76.1446,"Virginia Beach","VA"],"27320":[36.3432,-79.6642,"Reidsville","NC"],"29102":[33.6184,-80.2116,"Manning","SC"],"30144":[34.0287,-84.6047,"Kennesaw","GA"],"30518":[34.1124,-83.9965,"Buford","GA"],"31322":[32.1149,-81.252,"Pooler","GA"],"32218":[30.4507,-81.6626,"Jacksonville","FL"],"32824":[28.3932,-81.3622,"Orlando","FL"],"43207":[39.9046,-82.9703,"Columbus","OH"],"45315":[39.8551,-84.3399,"Clayton","OH"],"46036":[40.2803,-85.8391,"Elwood","IN"],"46140":[39.7902,-85.8141,"Greenfield","IN"],"49048":[42.3189,-85.5152,"Kalamazoo","MI"],"54101":[44.7869,-88.0571,"Abrams","WI"],"60436":[41.4884,-88.1572,"Joliet","IL"],"60446":[41.6404,-88.0696,"Romeoville","IL"],"65714":[37.0512,-93.2972,"Nixa","MO"],"75211":[32.7319,-96.9057,"Dallas","TX"],"76009":[32.4395,-97.213,"Alvarado","TX"],"76011":[32.7582,-97.1003,"Arlington","TX"],"76114":[32.7796,-97.3928,"Fort Worth","TX"],"77042":[29.7404,-95.5589,"Houston","TX"],"77423":[29.8072,-95.9755,"Brookshire","TX"],"77536":[29.6826,-95.1222,"Deer Park","TX"],"80216":[39.7835,-104.9669,"Denver","CO"],"84104":[40.7498,-111.926,"Salt Lake City","UT"],"85282":[33.3917,-111.9249,"Tempe","AZ"],"89030":[36.2115,-115.1241,"North Las Vegas","NV"],"90810":[33.8193,-118.2325,"Long Beach","CA"],"91702":[34.1248,-117.9031,"Azusa","CA"],"91744":[34.0289,-117.9373,"La Puente","CA"],"92590":[33.4903,-117.1824,"Temecula","CA"],"93725":[36.6207,-119.7308,"Fresno","CA"],"98032":[47.3776,-122.2854,"Kent","WA"],"98247":[48.9045,-122.3325,"Everson","WA"]}, SHOW_N = 3;

  function miles(la1, lo1, la2, lo2) {
    var R = 3958.8, t = Math.PI / 180;
    var dLa = (la2 - la1) * t, dLo = (lo2 - lo1) * t;
    var a = Math.sin(dLa/2)*Math.sin(dLa/2) + Math.cos(la1*t)*Math.cos(la2*t)*Math.sin(dLo/2)*Math.sin(dLo/2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  }
  function zipOf(s) { var m = (s || '').match(/\d{5}(?:-\d{4})?/g); return m ? m[m.length - 1].slice(0, 5) : null; }

  function initPicker(picker) {
    if (picker.__mgsWhInit) return; picker.__mgsWhInit = true;
    var list  = picker.querySelector('[data-mgs-wh-list]');
    var prop  = picker.querySelector('[data-mgs-pickup-prop]');
    var zipIn = picker.querySelector('[data-mgs-wh-zip]');
    var find  = picker.querySelector('[data-mgs-wh-find]');
    var msg   = picker.querySelector('[data-mgs-wh-msg]');
    var more  = picker.querySelector('[data-mgs-wh-more]');
    var cards = Array.prototype.slice.call(picker.querySelectorAll('[data-mgs-wh-card]'));
    var hasZip = !!zipIn;
    var count = cards.length;
    var mode = hasZip ? 'default' : 'all';   // 1-3 locations: always show
    var zipped = false;

    cards.forEach(function (card) {
      var addr = card.getAttribute('data-mgs-wh-address') || '';
      var g = ZG[zipOf(addr)];
      card._lat = g ? g[0] : null; card._lng = g ? g[1] : null;
      var head = card.querySelector('[data-mgs-wh-head]');
      if (head) head.textContent = g ? (g[2] + ', ' + g[3]) : 'Pickup location';
      var dir = card.querySelector('[data-mgs-wh-dir]');
      if (dir) dir.href = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(addr);
      var radio = card.querySelector('[data-mgs-wh-radio]');
      if (radio) radio.addEventListener('change', function () {
        if (radio.checked) { prop.value = addr; cards.forEach(function (c) { c.classList.toggle('is-selected', c === card); }); }
      });
    });

    function render() {
      if (!hasZip) return;
      if (mode === 'all') { cards.forEach(function (c) { c.hidden = false; }); if (more) more.textContent = 'Show fewer'; }
      else if (mode === 'zip') { cards.forEach(function (c, i) { c.hidden = i >= SHOW_N; }); if (more) more.textContent = 'Show all ' + count + ' locations'; }
      else { cards.forEach(function (c) { c.hidden = true; }); if (more) more.textContent = 'Browse all ' + count + ' locations'; }
      if (more) more.hidden = false;
    }
    render();
    if (more) more.addEventListener('click', function () { mode = (mode === 'all') ? (zipped ? 'zip' : 'default') : 'all'; render(); });

    function rankBy(lat, lng) {
      cards.forEach(function (c) { c._dist = (c._lat != null) ? miles(lat, lng, c._lat, c._lng) : Infinity; });
      cards.sort(function (a, b) { return a._dist - b._dist; });
      cards.forEach(function (c) {
        list.appendChild(c);
        var d = c.querySelector('[data-mgs-wh-dist]');
        if (d) d.textContent = isFinite(c._dist) ? ('~' + Math.round(c._dist) + ' mi') : '';
      });
      zipped = true; mode = 'zip'; render();
      var top = cards[0], r = top && top.querySelector('[data-mgs-wh-radio]');
      if (r) { r.checked = true; r.dispatchEvent(new Event('change')); }
      if (msg) { msg.textContent = 'Closest location selected — change it below if you prefer another.'; msg.hidden = false; }
    }
    function doFind() {
      var z = (zipIn.value || '').replace(/\D/g, '').slice(0, 5);
      if (z.length !== 5) { if (msg) { msg.textContent = 'Enter a 5-digit ZIP.'; msg.hidden = false; } return; }
      if (ZG[z]) { rankBy(ZG[z][0], ZG[z][1]); return; }
      if (msg) { msg.textContent = 'Finding closest location…'; msg.hidden = false; }
      fetch('https://api.zippopotam.us/us/' + z).then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (d) { var p = d.places[0]; rankBy(parseFloat(p.latitude), parseFloat(p.longitude)); })
        .catch(function () { if (msg) { msg.textContent = "Couldn't look up that ZIP — browse all locations below."; msg.hidden = false; } mode = 'all'; render(); });
    }
    if (find) find.addEventListener('click', doFind);
    if (zipIn) zipIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); doFind(); } });
    picker.classList.add('is-ready');
  }

  function boot() { document.querySelectorAll('[data-mgs-wh-picker]').forEach(initPicker); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
